// Anciennes URL du site kouoh.fr (Shopify) → nouvelles pages. Les plus précises d'abord, les jokers en dernier.
export const OLD_REDIRECTS = [
  ["/zones/antibes-sophia-antipolis", "/zones/antibes-juan-les-pins"],
  ["/pages/un-devis-gratuit-en-24h", "/demande"],
  ["/pages/history-quotes", "/espace-client"],
  ["/pages/broderie-automobile", "/secteurs/automobile-garages"],
  ["/pages/personnalisation-textiles-associations-sportives", "/secteurs/clubs-associations"],
  ["/pages/personnalisation-textiles-secteur-medical", "/secteurs/medical-sante"],
  ["/pages/personnalisation-broderie-hotels-restaurants", "/secteurs/hotels-restaurants"],
  ["/pages/personnalisation-textiles-evenementiel", "/secteurs/evenementiel-agences"],
  ["/pages/location-de-brodeuse-pour-vos-evenements-region-paca", "/broderie-evenement"],
  ["/pages/broderie-evenementielle", "/broderie-evenement"],
  ["/pages/broderie-monaco-personnalisation-textile", "/zones/monaco"],
  ["/pages/broderie-cannes-personnalisation-textile", "/zones/cannes"],
  ["/pages/broderie-menton-personnalisation-textile", "/zones/menton"],
  ["/pages/casquettes-personnalisees", "/casquettes-accessoires"],
  ["/pages/nos-techniques-de-personnalisation-textile", "/savoir-faire/broderie"],
  ["/pages/personnalisation-textile-start-up", "/secteurs/marques-createurs"],
  ["/pages/developpement-textile", "/secteurs/marques-createurs"],
  ["/pages/production-textile", "/projet-sur-mesure"],
  ["/pages/labo-kouoh", "/atelier"],
  ["/pages/nos-textiles", "/vetements-personnalises"],
  ["/blogs/infos/broderie-transfert-thermique-ou-serigraphie-comment-choisir", "/conseils/broderie-transfert-thermique-ou-serigraphie-comment-choisir"],
  ["/blogs/infos/creer-sa-marque-de-vetements-par-ou-commencer", "/conseils/creer-sa-marque-de-vetements-par-ou-commencer"],
  ["/blogs/infos/les-bienfaits-de-louer-une-brodeuse-pour-un-evenement-en-magasin", "/conseils/les-bienfaits-de-louer-une-brodeuse-pour-un-evenement-en-magasin"],
  ["/blogs/infos/grammage-d-un-t-shirt-personnalise-bien-choisir-son-mod-le", "/conseils/grammage-d-un-t-shirt-personnalise-bien-choisir-son-modele"],
  ["/blogs/infos/quels-sont-les-textiles-les-plus-ecologiques-pour-lancer-votre-marque", "/conseils/quels-sont-les-textiles-les-plus-ecologiques-pour-lancer-votre-marque"],
  ["/blogs/infos/les-tendances-textiles-pour-votre-association-sportive", "/conseils/les-tendances-textiles-pour-votre-association-sportive"],
  ["/blogs/infos/casquette-personnalisee-pourquoi-la-broderie-est-le-meilleur-choix", "/conseils/casquette-personnalisee-pourquoi-la-broderie-est-le-meilleur-choix"],
  ["/blogs/infos/textile-personnalise-pour-les-villas-de-luxe", "/conseils/textile-personnalise-pour-les-villas-de-luxe"],
  ["/blogs/infos/lanimation-marketing-la-plus-originale-de-la-region-paca-la-broderie-en-live", "/conseils/lanimation-marketing-la-plus-originale-de-la-region-paca-la-broderie-en-live"],
  ["/blogs/infos", "/conseils"],
  ["/collections/casquettes-bobs-bonnets", "/casquettes-accessoires"],
  ["/collections/textiles-evenementiel", "/broderie-evenement"],
  ["/collections/sport-wear", "/secteurs/sport-fitness"],
  ["/collections/work-wear", "/secteurs/immobilier-services"],
  ["/collections/street-wear-1", "/secteurs/marques-createurs"],
  ["/collections/*", "/vetements-personnalises"],
  ["/products/casquette-*", "/casquettes-accessoires"],
  ["/products/bob-*", "/casquettes-accessoires"],
  ["/products/bonnet-*", "/casquettes-accessoires"],
  ["/products/baroudeur-*", "/casquettes-accessoires"],
  ["/products/*", "/vetements-personnalises"],
  ["/blogs/*", "/conseils"],
  ["/pages/*", "/"],
];
